import React, {useMemo} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {EditableText, Intent, NavbarDivider, Spinner, Tag} from "@blueprintjs/core";

import {toggleShowSearch} from '../../../../store/actions/searchActions';
import NavigationMenu from './NavigationMenu';
import {ToggleFavorite} from '../../../Favorite';
import {ApiStatus, FavoriteType, Report} from '../../../../models';
import {IState} from '../../../../store/reducers';

import './ReportHeader.scss';
import {useCurrentUser, useReportIsDirty} from '../../../../hooks';
import {isPremise} from '../../../../utils/premise';
import {isAdmin} from '../../../../utils/auth';
import {isReport} from '../../../dialogs/SendJustToMeDialog/utils';

interface ReportHeaderProps {}

export const ReportHeaderLeft = ({

}: ReportHeaderProps) => {
  const report = useSelector((state: IState) => state.reportForm.report);
  const updating = useSelector((state: IState) => state.reportForm.updatingStatus);
  const isUpdating = useMemo(() => updating === ApiStatus.LOADING, [updating]);
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const reportExists = !!report?.id;
  const {isDirty} = useReportIsDirty();
  /*
   * Users on Premise cannot see "Administration" menu
   */
  const showAdministrationMenu = !(isPremise() && !isAdmin(currentUser));

  const onSearch = () => {
    dispatch(toggleShowSearch());
  };

  return (
    <>
      <NavigationMenu
        showAdministrationMenu={showAdministrationMenu}
        onSearch={onSearch}
      />
      <NavbarDivider/>
      {
        reportExists ? (
          <>
            <ToggleFavorite
              type={FavoriteType.REPORT}
              id={report?.id as any}
            />
            <EditableText
              className="header__report__name"
              value={report?.name}
              disabled={true}
            />
            {
              isReport(report as Report) && isDirty &&
              (
                <span className="header__report__draft">
                  <Tag
                    intent={Intent.WARNING}
                    minimal={true}
                    round={true}
                  >
                    You have unsaved changes
                  </Tag>
                </span>
              )
            }
            {isUpdating && <span>Saving...</span>}
          </>
        ) : <Spinner size={16}/>
      }
    </>
  );
}

export default ReportHeaderLeft;
